import styled from 'styled-components';

export const CardWrapper = styled.div`
  border: 1px solid rgba(255, 255, 255, 0.25);

  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
`;

export const InfoWrapper = styled.div`
  padding: 4rem 3rem 0;
  @media (${({ theme }) => theme.respondTo.desktop}) {
    padding: 5rem 3rem 0;
  }
`;
export const TitleWrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  gap: 2rem;
`;

export const Title = styled.h3`
  font-family: var(--font-tertiary);
  font-size: 2.5rem;
  @media (${({ theme }) => theme.respondTo.desktop}) {
    font-size: 2.1rem;
  }
`;
export const Text = styled.p`
  margin-top: 3.4rem;
`;

export const Price = styled.p`
  line-height: 1;
  font-size: 2.5rem;
  color: var(--color-secondary);
  font-family: var(--font-secondary);
`;

export const PriceLabel = styled.p`
  margin-top: 0;
  font-size: 1.3rem;
  font-weight: var(--font-weight-semibold);
`;

export const ButtonWrapper = styled.div`
  align-self: flex-end;
  margin-top: 3rem;
  @media (${({ theme }) => theme.respondTo.desktop}) {
    margin-top: 6rem;
  }
`;
